<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolAdmissionManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/admission/online-admission",
                title: "Online Admission",
                description: "Review online applications and manage applicant details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Entrance Examination",
                description: "Set up and manage entrance exams for applicants.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
